<template>
  <div class="user-card">
    <div class="user-card__wrapper" v-if="user">
      <div class="user-card__user-avatar">
        <div class="user-card__user-avatar__image-wrapper">
          <img
            v-if="user && user.avatar"
            :src="getImageSource(user.avatar)"
            class="user-card__user-avatar__image"
          />
          <r-icon name="user" :size="16" />
        </div>
      </div>
      <div v-if="user.name" class="user-card__user-info">
        <div class="user-card__user-info__name">
          <r-text style="font-weight: bold">{{ user.name }}</r-text>
        </div>
        <div v-if="user.position" class="user-card__user-info__description">
          <r-text type="caption" style="font-weight: italic">
            {{ user.position }}
          </r-text>
        </div>
      </div>
    </div>
    <div class="user-card__wrapper empty" v-else-if="content">
      <div class="user-card__user-avatar">
        <div class="user-card__user-avatar__image-wrapper">
          <i class="el-icon-plus" />
        </div>
      </div>
      <div class="user-card__user-info">
        <div class="user-card__user-info__name">
          <r-text style="font-weight: bold">{{ content }}</r-text>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import constants from "@/constants/url";

export default {
  props: { user: Object, content: String },
  data() {
    return {
      downloadURL: "download_share_resource",
      baseURL: constants.URL
    };
  },
  methods: {
    getImageSource(file) {
      return `${this.baseURL}/${this.downloadURL}/${file}`;
    }
  }
};
</script>

<style lang="scss">
.user-card {
  height: 60px;
  &__wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    padding: 8px;
    border-radius: var(--border-radius);
    border: 1px solid;
    transition: border-color 0.12s ease;
    border-color: var(--dividers_low_contrast) !important;
    background-color: var(--field_bg) !important;
    &:hover {
      border-color: var(--accent_primary) !important;
    }
    &.empty {
      border: 1px dashed;
      .user-card__user-avatar {
        border: 1px dashed;
        width: 38px;
        height: 38px;
        border-color: var(--dividers_low_contrast) !important;
        &__image-wrapper {
          display: flex;
          align-items: center;
          justify-content: center;
          background: none !important;
          color: var(--text_secondary) !important;
        }
      }
    }
  }
  &__user {
    &-avatar {
      height: 40px;
      width: 40px;
      overflow: hidden;
      border-radius: 50%;
      position: relative;
      margin-right: 8px;
      &__image {
        height: 100%;
        width: 100%;
        top: 50%;
        left: 50%;
        box-sizing: border-box;
        &-wrapper {
          height: 100%;
          width: 100%;
          background-color: var(--bg_containers) !important;
        }
      }
    }
    &-info {
      height: 100%;
      width: 162px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      &__name,
      &__description,
      .r-text,
      .r-text.caption-2 {
        text-align: start;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 162px;
      }
      &__description {
        padding-top: 4px;
      }
    }
  }
}
</style>
